module.exports = __webpack_public_path__ + "static/media/f_eyeshape_round_lightbrown.98d77bc5.png";